define([
	"dojo/_base/declare",
	"./_ReviewNumber"
], function(declare,_ReviewNumber) {

	return declare(_ReviewNumber, {
		cssBaseSize: " PatternWithShrinkageBase",
		cssOffBaseSize: " PatternWithShrinkageOffBase"
	});
});